import DEFAULT_TEXTS from './displayTexts.json';
export { DEFAULT_TEXTS };
export function normalizeDisplayLayout(value, resourceType = 'gate') {
  const texts = Object.fromEntries(Object.entries(DEFAULT_TEXTS).map(([key, fallback]) => [
    key, typeof value?.texts?.[key] === 'string' && value.texts[key].trim() ? value.texts[key].trim() : fallback,
  ]));
  return { version: 3, resourceType, texts };
}
export const defaultDisplayLayout = (type = 'gate') => normalizeDisplayLayout(null, type);
export function formatDisplayText(text, values = {}) {
  return String(text || '').replace(/\{([^{}]+)\}/g, (token, key) => Object.prototype.hasOwnProperty.call(values, key) ? String(values[key]) : token);
}
